import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../../services/http.service';
import {AiFuntionDialogComponent} from '../ai-funtion-dialog/ai-funtion-dialog.component';
import {AiFunctionDialogComponent} from '../ai-function-dialog/ai-function-dialog.component';
import {CodemirrorComponent} from "@ctrl/ngx-codemirror";

@Component({
  selector: 'app-ai-settings-dialog',
  templateUrl: './ai-settings-dialog.component.html',
  styleUrls: ['./ai-settings-dialog.component.scss']
})
export class AiSettingsDialogComponent implements OnInit {
  @ViewChild('codeMirror') private codeEditorCmp?: CodemirrorComponent;
  public codemirrorContent: string = '';
  public codeReady: boolean = false;
  public lineNumber: number = 0;
  public charNumber: number = 0;
  private filterModel: any = null;
  public codemirrorConfig: any = {
    lineNumbers: true,
    // theme: 'material',
    mode: 'javascript'
  }
  public config: any = [
    {
      index: 0,
      prompt: 'How often do you want to check for updates?',
      n: 1,
      temperature: 0.6,
      presence_penalty: 1,
      frequency_penalty: 1,
      codemirrorContent: '',
      top_p: 1,
      logit_bias: {},
      chunk_size: 1,
      json: true,
      function: '',
      deactivate: false
    }
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AiSettingsDialogComponent>,
    private httpService: HttpService,
  ) {
    this.filterModel = data.filterModel;
  }

  ngOnInit(): void {
    this.httpService.get(environment.API_PATH + '/ai/config').subscribe(res => {
      this.config = res || [{
        index: 0,
        chunk_size: 1,
        json: true,
        function: '',
        deactivate: false
      }];
      setTimeout(() => {
        this.codeReady = true;
      }, 100);
    });
  }

  cursorActivity($event: any): void {
    this.lineNumber = this.codeEditorCmp?.codeMirror?.getCursor().line || 0;
    this.charNumber = this.codeEditorCmp?.codeMirror?.getCursor().ch || 0;
    // console.log('cursorActivity', this.lineNumber, this.charNumber);
    const content = this.codeEditorCmp?.codeMirror?.getValue() || '';
  }

  setEditorContent(event: any) {
    setTimeout(() => {
      // console.log('this.codeEditorCmp2?.toArray()', this.codeEditorCmp2?.toArray());
      // this.restoreTags(this.codeEditorCmp2?.toArray());
    }, 4000)
  }

  addFunction(index: number) {
    this.dialog.open(AiFunctionDialogComponent, {
      width: '40%',
      maxWidth: '750px',
      maxHeight: '500px',
      disableClose: true,
      data: this.config[index]
    }).afterClosed().subscribe(res => {
      console.log('res', res);
      if (res) {
        this.config[index].function = res;
      } else if (res === 'null') {
        this.config[index].function = '';
      }
    });
  }

  runTest(index: number) {
    this.httpService.post(environment.API_PATH + '/ai/runTest', {
      config: this.config[index],
      filterModel: this.filterModel
    }).subscribe(response => {

    });
  }

  deleteStep(index: number): void {
    this.config = this.config.filter((_: any, i: any) => i!== index);
  }

  addStep(): void {
    this.config.push({
      index: this.config.length,
      chunk_size: 1,
      json: false,
      function: '',
      deactivate: false
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.httpService.post(environment.API_PATH + '/ai/config', {
      gptConfig: this.config
    }).subscribe(response => {
      this.dialogRef.close();
    });
  }
}
